import React from 'react';
import Navbar from '../components/Navbar';

const featuredBrand = {
 name: 'By Tianna Osbourne',
 product: 'Caribbean Flags x NY Baby Tee',
 price: '$50.00',
 link: 'https://tiannaosbourne.com/products/jamaica-yankee-logo-tee',
 logo: 'https://tiannaosbourne.com/cdn/shop/files/BTO_logos_-2.png?v=1681307518&width=500',
 images: [
  'https://tiannaosbourne.com/cdn/shop/files/Photoroom_20250516_183229.jpg?v=1747434878&width=1100',
  'https://tiannaosbourne.com/cdn/shop/files/IMG_3624.jpg?v=1760713916&width=1100',
  'https://tiannaosbourne.com/cdn/shop/files/IMG_3625.jpg?v=1760713916&width=1100',
 ],
 story: 'A Bronx-based fashion brand making pieces that feel personal, cultural, and city-rooted. This tee brings Caribbean pride and New York energy together in one clean statement piece.',
 tags: ['Bronx Studio', 'Caribbean Flags', 'NY Baby Tee'],
};

export default function Shop() {
 return (
  <div className="flyshit-shop-page flyshit-shop-page--deck">
   <Navbar theme="dark" />

   <main>
    <section className="flyshit-shop-deck-hero">
     <div className="flyshit-shop-deck-hero__copy">
      <h1>
       <span>SHOPWITH</span>
       <span>FLYSHITNYC</span>
      </h1>
      <p>
       Here we feature brands where your money is spent well, buy into not only their brand but their story.
      </p>
      <a href="#featured-brand" className="flyshit-shop-deck-hero__cta">Shop the feature ↓</a>
     </div>

     <img className="flyshit-shop-deck-hero__pigeon" src="/assets/flyshit-pigeon.png" alt="FlyShitNYC pigeon" />
    </section>

    <section id="featured-brand" className="flyshit-shop-feature-section">
     <div className="flyshit-shop-feature-section__heading">
      <p>Featured brand</p>
      <h2>Buy into the story.</h2>
     </div>

     <article className="flyshit-shop-feature-card">
      <div className="flyshit-shop-feature-card__media">
       <img className="flyshit-shop-feature-card__main-image" src={featuredBrand.images[0]} alt={featuredBrand.product} />
       <div className="flyshit-shop-feature-card__side-images">
        {featuredBrand.images.slice(1).map((image) => (
         <img key={image} src={image} alt={featuredBrand.product} />
        ))}
       </div>
      </div>

      <div className="flyshit-shop-feature-card__copy">
       <img className="flyshit-shop-feature-card__logo" src={featuredBrand.logo} alt={featuredBrand.name} />
       <p className="flyshit-shop-feature-card__eyebrow">{featuredBrand.name}</p>
       <h3>{featuredBrand.product}</h3>
       <p>{featuredBrand.story}</p>
       <div className="flyshit-shop-feature-card__tags">
        {featuredBrand.tags.map((tag) => <span key={tag}>{tag}</span>)}
       </div>
       <div className="flyshit-shop-feature-card__bottom">
        <strong>{featuredBrand.price}</strong>
        <a href={featuredBrand.link} target="_blank" rel="noreferrer">Shop now →</a>
       </div>
      </div>
     </article>
    </section>
   </main>
  </div>
 );
}
